import WorkOrderSupplyDetail from '@/models/WorkOrderSupply/WorkOrderSupplyDetail';

export default class WorkOrderSupplyDetailFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.workOrderSupplyId  = '';
		this.workOrderSupplyWorkOrderSupplyDate = '';
		this.partId  = '';
		this.partPartNumber = '';
		this.materialPartId  = '';
		this.materialPartPartNumber = '';
		this.workOrderProcessDetailId  = '';
		this.workOrderProcessDetailPart = '';
		this.partName = '';
		this.billOfMaterialDetailId  = '';
		this.billOfMaterialDetailPartNumber = '';
		this.customerId  = '';
		this.customerCode = '';
		this.qtyPlan = '';
		this.qtyConsumption = '';
		this.qtyTransit = '';
		this.qtyStock = '';
		this.qtySupply = '';
		this.uomId  = '';
		this.uomCode = '';
		this.remarkMultiple = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			workOrderSupplyId : '0',
			workOrderSupplyWorkOrderSupplyDate : '0',
			partId : '0',
			partPartNumber : '0',
			materialPartId : '0',
			materialPartPartNumber : '0',
			workOrderProcessDetailId : '0',
			workOrderProcessDetailPart : '0',
			partName : '0',
			billOfMaterialDetailId : '0',
			billOfMaterialDetailPartNumber : '0',
			customerId : '0',
			customerCode : '0',
			qtyPlan : '0',
			qtyConsumption : '0',
			qtyTransit : '0',
			qtyStock : '0',
			qtySupply : '0',
			uomId : '0',
			uomCode : '0',
			remarkMultiple : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}